"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileUtils = void 0;
var profile_1 = require("../schemas/profile");
var profile_2 = require("../models/profile");
var food_1 = require("../schemas/offers/products/food");
var ProfileUtils = /** @class */ (function () {
    function ProfileUtils() {
    }
    ProfileUtils.trainingDataToDog = function (trainingData) {
        return {
            id: trainingData.__dog_id,
            name: 'unknown',
            img: '',
            touched: false,
            // @TODO detection and input of these fields
            neutered: trainingData.dog_neutered,
            obeseProne: trainingData.dog_obese_prone,
            bones: 0,
            gender: trainingData.dog_gender,
            breeds: trainingData.dog_breeds,
            dogSize: trainingData.dog_breed_size,
            dob: trainingData.dog_dob,
            personality: {
                // @TODO include more - chew
                pickiness: 1,
                chewAmount: trainingData.dog_chew_amount
            },
            activity: {
                exerciseAmount: 1,
                dailyFeedAmount: 2
            },
            /**
             * @deprecated - this should be handled by breed
             */
            type: 'NORMAL',
            size: {
                weight: {
                    value: (trainingData.dog_weight_lbs_min + trainingData.dog_weight_lbs_max) / 2,
                    measurement: 'lbs'
                },
                length: {
                    value: (trainingData.dog_body_length_inches_min + trainingData.dog_body_length_inches_max) / 2,
                    measurement: 'in'
                },
                chest: {
                    value: (trainingData.dog_chest_girth_inches_min + trainingData.dog_chest_girth_inches_max) / 2,
                    measurement: 'in'
                },
                neck: {
                    value: (trainingData.dog_neck_girth_inches_min + trainingData.dog_neck_girth_inches_max) / 2,
                    measurement: 'in'
                },
                heightFromShoulder: {
                    value: (trainingData.dog_height_from_shoulder_inches_min + trainingData.dog_height_from_shoulder_inches_max) / 2,
                    measurement: 'in'
                }
            },
            growth: [],
            allergies: trainingData.dog_allergies,
            dietPreferences: []
        };
    };
    /**
     * Get the dog's estimate life stage
     */
    ProfileUtils.estimateDogLifeStage = function (dog, breeds) {
        var age = this.estimateDogAgeKey(dog);
        var size = this.estimateBreedSize(dog, breeds);
        return this.LIFESTAGE_REFERENCE[size][age];
    };
    /**
     * Provides dogs estimated breed size based on the given breed attributes
     * @param dog
     * @param breeds - can provide only the breeds the dog belongs to
     */
    ProfileUtils.estimateBreedSize = function (dog, breeds) {
        var points = 0;
        var count = 0;
        var pointMap = {
            TOY: 1,
            SMALL: 2,
            MEDIUM: 3,
            LARGE: 4,
            GIANT: 5
        };
        var pointMapInverse = {
            1: profile_1.BreedSize.TOY,
            2: profile_1.BreedSize.SMALL,
            3: profile_1.BreedSize.MEDIUM,
            4: profile_1.BreedSize.LARGE,
            5: profile_1.BreedSize.GIANT
        };
        var _loop_1 = function (id) {
            try {
                var breed = breeds[breeds.findIndex(function (b) { return b.id === id; })];
                points += pointMap[breed.size];
                count++;
            }
            catch (err) {
                if (id === '') {
                    console.error("Provided empty breed string");
                }
                console.error("Breed \"" + id + "\" does not exist in provided breed list (" + breeds.length + " breeds)");
                if (breeds.length < 10) {
                    console.error("\t Expected to have " + breeds.map(function (b) { return "\"" + b.id + "\""; }).join(', ') + ", but got \"" + id + "\"");
                }
            }
        };
        for (var _i = 0, _a = dog.breeds; _i < _a.length; _i++) {
            var id = _a[_i];
            _loop_1(id);
        }
        var score = Math.ceil(points / count);
        if (pointMapInverse.hasOwnProperty(score)) {
            return pointMapInverse[score];
        }
        else {
            console.error("Could not associate breed size from given score \"" + score + "\", check the .breeds input => " + dog.breeds.map(function (id) { return "\"" + id + "\""; }).join(', '));
            return profile_1.BreedSize.MEDIUM;
        }
    };
    /**
     * Determine which age key belongs to the profile - used for determining preloaded data
     */
    ProfileUtils.estimateDogAgeKey = function (dog) {
        var monthsOld = profile_2.Dog.ageFrom(dog.dob, 'month');
        // 3 months old
        var ref = ['1_MONTH', 1, Infinity];
        for (var key in this.ageMap) {
            if (!this.ageMap.hasOwnProperty(key)) {
                continue;
            }
            var month = this.ageMap[key];
            var ratio = Math.abs(1 - month / monthsOld);
            if (ratio < ref[2]) {
                ref[0] = key;
                ref[1] = month;
                ref[2] = ratio;
            }
        }
        return ref[0];
    };
    ProfileUtils.budgetLevel = function (owner) {
        var limit = owner.budget.yearlyLimit;
        if (limit < 700) {
            return 'LOW';
        }
        else if (limit > 700 && limit < 1400) {
            return 'MEDIUM';
        }
        else {
            return 'HIGH';
        }
    };
    // Based on scout9-models preloaded data sets
    ProfileUtils.ageMap = {
        '1_MONTH': 1,
        '3_MONTH': 3,
        '6_MONTH': 6,
        '8_MONTH': 8,
        '1_YEAR': 12,
        '2_YEAR': 24,
        '5_YEAR': 60,
        '10_YEAR': 120
    };
    ProfileUtils.LIFESTAGE_REFERENCE = {
        TOY: {
            '1_MONTH': food_1.LifeStage.NEW_BORN,
            '3_MONTH': food_1.LifeStage.PUPPY,
            '6_MONTH': food_1.LifeStage.PUPPY,
            '8_MONTH': food_1.LifeStage.ADULT,
            '1_YEAR': food_1.LifeStage.ADULT,
            '2_YEAR': food_1.LifeStage.ADULT,
            '5_YEAR': food_1.LifeStage.ADULT,
            '10_YEAR': food_1.LifeStage.ADULT
        },
        SMALL: {
            '1_MONTH': food_1.LifeStage.NEW_BORN,
            '3_MONTH': food_1.LifeStage.PUPPY,
            '6_MONTH': food_1.LifeStage.PUPPY,
            '8_MONTH': food_1.LifeStage.PUPPY,
            '1_YEAR': food_1.LifeStage.ADULT,
            '2_YEAR': food_1.LifeStage.ADULT,
            '5_YEAR': food_1.LifeStage.ADULT,
            '10_YEAR': food_1.LifeStage.ADULT
        },
        MEDIUM: {
            '1_MONTH': food_1.LifeStage.NEW_BORN,
            '3_MONTH': food_1.LifeStage.PUPPY,
            '6_MONTH': food_1.LifeStage.PUPPY,
            '8_MONTH': food_1.LifeStage.PUPPY,
            '1_YEAR': food_1.LifeStage.ADULT,
            '2_YEAR': food_1.LifeStage.ADULT,
            '5_YEAR': food_1.LifeStage.ADULT,
            '10_YEAR': food_1.LifeStage.SENIOR
        },
        LARGE: {
            '1_MONTH': food_1.LifeStage.NEW_BORN,
            '3_MONTH': food_1.LifeStage.PUPPY,
            '6_MONTH': food_1.LifeStage.PUPPY,
            '8_MONTH': food_1.LifeStage.PUPPY,
            '1_YEAR': food_1.LifeStage.PUPPY,
            '2_YEAR': food_1.LifeStage.ADULT,
            '5_YEAR': food_1.LifeStage.ADULT,
            '10_YEAR': food_1.LifeStage.SENIOR
        },
        GIANT: {
            '1_MONTH': food_1.LifeStage.NEW_BORN,
            '3_MONTH': food_1.LifeStage.PUPPY,
            '6_MONTH': food_1.LifeStage.PUPPY,
            '8_MONTH': food_1.LifeStage.PUPPY,
            '1_YEAR': food_1.LifeStage.PUPPY,
            '2_YEAR': food_1.LifeStage.ADULT,
            '5_YEAR': food_1.LifeStage.ADULT,
            '10_YEAR': food_1.LifeStage.SENIOR
        }
    };
    return ProfileUtils;
}());
exports.ProfileUtils = ProfileUtils;
